module.exports = __webpack_public_path__ + "img/bg.51790655.svg";